const ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/bmp',
  'image/webp',
  'image/gif',
  'image/svg+xml',
  'application/pdf'
]

export default function validateUpload(file) {
  const isValid = ALLOWED_TYPES.includes(file.type)
  const isImage = file.type !== 'application/pdf'
  const isPdf = file.type === 'application/pdf'

  return { isValid, isImage, isPdf }
}
